import { Injectable, signal } from '@angular/core';
import { BankAccountsStore } from './bank-accounts.store';
import { GetQrPaymentResponse, QRPaymentEnum } from './types';
import { Router } from '@angular/router';
import { PaymentService } from '../services/payment.service';

export type QrPaymentAccountData = {
  accountNumber: string;
  currency: { code: string; name: string; symbol: string };
  accountType: string;
  customer: {
    firstName: string;
    lastName: string;
    email: string;
    fullName: string;
  };
};

@Injectable({
  providedIn: 'root'
})
export class QrTransferStore {
  qrPaymentAccountData = signal<QrPaymentAccountData | null>(null);
	qrPaymentGeneratedData = signal<GetQrPaymentResponse | null>(null);
	accountNumberOrSessionId = signal<string | null>(null);

  constructor(
    private bankAccountsStore: BankAccountsStore,
    private router: Router,
    private paymentService: PaymentService
  ) {}

  async manageQrPayment(type: QRPaymentEnum, accountNumberOrSessionId: string) {
    if (type === QRPaymentEnum.ACCOUNT_QR) {
      this.qrPaymentGeneratedData.set(null);
      const res = await this.bankAccountsStore.loadAccountInfo(accountNumberOrSessionId);
      if (!res) return;

      this.qrPaymentAccountData.set(res);
      this.router.navigate(['transfer'], { queryParams: { fromQr: true } });
    } else if (type === QRPaymentEnum.GENERATED_QR) {
      this.qrPaymentAccountData.set(null);
      const res = await this.loadQrPaymentData(accountNumberOrSessionId);
      if (!res) return;

      this.router.navigate(['transfer'], { queryParams: { fromCustomQr: true } });
    }
  }

  async loadQrPaymentData(sessionId: string) {
    const res = await this.paymentService.loadPaymentAsQr(sessionId, false);
    if (!res.data) return false;

		this.qrPaymentGeneratedData.set(res.data);
		this.accountNumberOrSessionId.set(sessionId)
    return res.data;
  }
}
